<template>
    <el-row class="main-box flex-cloumn flex1">
        <el-col>
            <el-row>
                <el-col>
                    <div class="head-box flex-column">
                        <el-image class="head-box-bg" src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image2.jpg" fit="cover"
                            :lazy="true"></el-image>
                        <div class="head-box-text1">词汇量测试</div>
                        <div class="head-box-text2">知识源于积累</div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 22, offset: 1 }"
                    :lg="{ span: 22, offset: 1 }">

                    <template v-if="userInfos.role == 0">
                        <div class="content-box flex-cloumn ">
                            <span class="content-box-title">花几分钟测试一下，定位你的词汇量水平</span>
                            <div class="content-box-bottom">
                                <el-image class="content-box-bottom-bg"
                                    :src="require('@/static/vocabulary-text-contetn-bg.png')" fit="fill"
                                    :lazy="true"></el-image>
                                <div class="content-box-main flex-row f-align-center f-justify-between">
                                    <div class="flex-row f-align-center">
                                        <img src="../static/book_badge.png" alt="">
                                        <div class="content-box-main-info">
                                            <div>词汇量测试</div>
                                            <div>Vocabulary</div>
                                        </div>
                                    </div>
                                    <div @click="startHandle" class="content-box-main-btn">开始</div>

                                </div>
                                <el-image class="content-box-bottom-badge"
                                    src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image5.jpg" fit="cover"
                                    :lazy="true"></el-image>

                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="content-box2 flex-cloumn ">
                            <div class="content-box2-tips flex-row f-align-center">
                                <img src="../static/notepad_badge.png" alt="">
                                <span>我的课程</span>
                            </div>
                            <div class="content-box-titlebox flex-row">
                                <span class="content-box-title">让我们开始学习吧</span>
                                <span class="content-box-title2">课程倒计时{{djtimer}}</span>
                            </div>
                            <div class="content-box-bottom">
                                <el-image class="content-box-bottom-bg"
                                    :src="require('@/static/vocabulary-text-contetn-bg.png')" fit="fill"
                                    :lazy="true"></el-image>
                                <div class="content-box-mainbox flex-row">
									<div @click="toWordRecognise"
									    class="content-box-main flex-row f-align-center f-justify-between">
									    <div class="flex-row f-align-center" style="cursor: pointer;">
									        <img src="../static/class-badge.png" alt="">
									        <div class="content-box-main-info">
									            <div>单词识别</div>
									            <div>Word</div>
									        </div>
									    </div>
									</div>
									<div @click="topdTest"
									    class="content-box-main flex-row f-align-center f-justify-between">
									    <div class="flex-row f-align-center" style="cursor: pointer;">
									       <img style="width: 100px;height: 91px;" src="../static/zrpd_ic1.png" alt="">
									       <div class="content-box-main-info">
									           <div>简拼读</div>
									           <div>Phonics</div>
									       </div>
									    </div>
									</div>
                                   
                                   
                                    <div
									 @click="toWordread"
									 class="content-box-main flex-row f-align-center f-justify-between">
                                        <div class="flex-row f-align-center" style="cursor: pointer;">
                                            <img src="../static/class-book.png" alt="">
                                            <div class="content-box-main-info">
                                                <div>阅读</div>
                                                <div>Reading</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
								
								<div class=" flex-row" style="margin-top: 20px; margin-left: 49px;">
								  <div @click="tokcTest"
								      class="content-box-main flex-row f-align-center f-justify-between">
								      <div class="flex-row f-align-center" style="cursor: pointer;">
								  		<img src="../static/book_badge.png" alt="">
								  		<div class="content-box-main-info">
								  		    <div>词汇量测试</div>
								  		    <div>Vocabulary</div>
								  		</div>
								      </div>
								  </div>
								   <div @click="toWordTest"
								       class="content-box-main flex-row f-align-center f-justify-between">
								       <div class="flex-row f-align-center" style="cursor: pointer;">
								          <img src="../static/voc_ic1.png" alt="">
								          <div class="content-box-main-info">
								              <div>词库测试</div>
								              <div>Test</div>
								          </div>
								       </div>
								   </div>
								   
								</div>
                                <div class="content-box-btnsbox flex-row f-align-center">
                                    <div style="cursor: pointer;" @click="closeclass()">结束课程</div>
                                    <div style="cursor: pointer;" @click="closeclass2()">结束课程并创建抗遗忘计划</div>
                                </div>
                                <el-image class="content-box-bottom-badge"
                                   src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image5.jpg" fit="cover"
                                    :lazy="true"></el-image>
                            </div>
                        </div>
                    </template>


                </el-col>
            </el-row>

        </el-col>

        <el-dialog title="" :center="true" :visible.sync="dialogStartClass" :show-close="false">

            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogStartClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column  " >
                        <span class="start-popup-content-text2" style="margin-top: 29px;">结束课程并创建抗遗忘计划</span>
                        <div  class="start-popup-content-timebox2 flex-row f-justify-between f-align-center" 
						style="margin-top: 30px;width: 350px;margin-left:  auto; margin-right: auto;">
                            <span>复习时间</span>
                            <el-select class="content-box2-select"  v-model="fxtime" placeholder="请选择">
                                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
						
						<div  class="start-popup-content-timebox2 flex-row f-justify-between f-align-center" 
						style="margin-top: 20px;width: 350px;margin-left:  auto; margin-right: auto;">
						    <span>班主任</span>
						    <el-select class="content-box2-select"  filterable   v-model="fxtime2" placeholder="请选择"
						    >
						        <el-option v-for="item in options2" :key="item.id" :label="item.userName" :value="item.id">
						        </el-option>
						    </el-select>
						</div>
						<div v-if="classType==0" class="start-popup-content-timebox2 flex-row f-justify-between f-align-center" 
						style="margin-top: 20px;width: 350px;margin-left:  auto; margin-right: auto;">
											    <span>活动</span>
						<el-select class="content-box2-select"  filterable   v-model="fxtime3" placeholder="请选择">
							<el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.id">
											        </el-option>
											    </el-select>
							</div>
							
							<!-- v-if="options4.length>0" -->
							<div  class="start-popup-content-timebox2 flex-row f-justify-between f-align-center"
							style="margin-top: 20px;width: 350px;margin-left:  auto; margin-right: auto;">
												    <span>备注</span>
								<div>
							<el-select class="content-box2-select"  filterable @change="selectvlue"    v-model="fxtime4" placeholder="请选择">
								<el-option v-for="item in options4" :key="item.dictLabel" :label="item.dictLabel" :value="item.dictLabel">
												        </el-option>
												    </el-select>
															</div>
								</div>
								<el-input v-if="dictValue==9" class="appraise-popup-content-textbox-input" type="textarea" maxlength="200"
								    :autosize="{ minRows: 2, maxRows: 8 }" placeholder="请输入理由" v-model="appraiseText">
								</el-input>
							<div class="start-popup-content-line"></div>
							<div class="start-popup-content-btnsbox flex-row f-justify-end">
							   <div style="cursor: pointer;" @click="dialogStartClass = false">返回</div>
							   <div style="cursor: pointer;" @click="closeclassrequst(1)">结束</div>
							</div>
                    </div>

                </el-col>
            </el-row>
        </el-dialog>


		<el-dialog title="" :center="true" :visible.sync="dialogStartClass2" :show-close="false">
		
		    <el-row slot="title" style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
		                <div style="width:56px;height:56px;"></div>
		                <span class="appraise-popup-title-name">提示</span>
		                <img @click="dialogStartClass2 = false" src="../static/close.png" alt="">
		            </div>
		        </el-col>
		    </el-row>
		    <el-row style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="start-popup-content flex-column f-center">
		                <span class="start-popup-content-text1" style="margin-left: 0;margin-top: 30px;">确定现在结束课程?</span>
						<div  class="start-popup-content-timebox2 flex-row f-justify-between f-align-center"
						style="margin-top: 40px;width: 350px;margin-left:  auto; margin-right: auto;">
											    <span>备注</span>
							<div>
							<el-select class="content-box2-select"  filterable @change="selectvlue" 
							 v-model="fxtime4" 
							 placeholder="请选择">
									<el-option v-for="(item,index) in options4" :key="item.dictLabel" :label="item.dictLabel" :value="item.dictLabel">
											        </el-option>
									</el-select>
							</div>
							</div>
							<el-input v-if="dictValue==9" class="appraise-popup-content-textbox-input" type="textarea" maxlength="200"
							    :autosize="{ minRows: 2, maxRows: 8 }" placeholder="请输入理由" v-model="appraiseText">
							</el-input>
		                <div class="start-popup-content-line"></div>
		                <div class="start-popup-content-btnsbox flex-row f-justify-end">
		                  <div style="cursor: pointer;" @click="dialogStartClass2 = false">返回</div>
		                  <div style="cursor: pointer;" @click="closeclassrequst(0)">结束</div>
		                </div>
		            </div>
		        </el-col>
		    </el-row>
		</el-dialog>

		<el-dialog title="" :center="true" :visible.sync="dialogStartClass3" :show-close="false">
					<el-row slot="title" style="width: 100%;">
						<el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
							<div class="appraise-popup-title flex-row f-justify-between f-align-center">
								<div style="width:56px;height:56px;"></div>
								<span class="appraise-popup-title-name">提示</span>
							</div>
						</el-col>
					</el-row>
					<el-row style="width: 100%;">
						<el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
							<div class="start-popup-content flex-column ">
								<span class="start-popup-content-text1">上课结束，恭喜获得积分</span>
								<div class="start-popup-content-line"></div>
								<div class="start-popup-content-btnsbox flex-row f-justify-end">
								  <div style="cursor: pointer;" @click="closeclassrequst2()">确定</div>
								</div>
							</div>
						</el-col>
					</el-row>
		</el-dialog>
				

        <el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column f-align-center">
                        <div class="start-popup-content-tipsbox flex-row f-align-center">
                            <span>确认开始学员 <span style="color:#0AA26B;"> 谢志鹏</span> 的课程吗</span>
                        </div>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
                            <div>返回</div>
                            <div @click="startSubmit">提交</div>
                        </div>
                    </div>
                </el-col>
            </el-row>

        </el-dialog>

    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    data() {
        return {
            dialogStartClass: false,
			dialogStartClass2: false,
			dialogStartClass3: false,
            dialogConfrimStartClass: false,	 
			planId:"",
			courseId:"",
			studentId:"",
			courseName:"",
			fxtime:"",
			fxtime2:"",
			fxtime3:"",
			fxtime4:"",
			dictValue:-1,
			classType:0,
			courseType:0,
			options: [
				"5:00","5:30","6:00","6:30","7:00","7:30",
				            "8:00","8:30","9:00","9:30","10:00","10:30",
				            "11:00","11:30","12:00","12:30","13:00","13:30",
				            "14:00","14:30","15:00","15:30","16:00","16:30",
				            "17:00","17:30","18:00","18:30","19:00","19:30",
				            "20:00","20:30","21:00","21:30","22:00","22:30",
				            "23:00"
			],
			options2:[],
			options3:[],
			options4:[],
			timer: null,//
			djtimer:"00:00",
			appraiseText:"",
			
			countdown:1,
        }
    },
	created() {
		  this.planId = decodeURIComponent(this.$route.query.planId);
		    this.courseId = decodeURIComponent(this.$route.query.courseId);
			this.studentId= decodeURIComponent(this.$route.query.studentId);
			this.courseName= decodeURIComponent(this.$route.query.courseName);
			
			this.courseType= decodeURIComponent(this.$route.query.courseType);
			
			
			this.classType=this.$route.query.classType;
			
			this.attendClassEndTime = decodeURIComponent(this.$route.query.attendClassEndTime);
			this.timeFn();
	},
	 beforeDestroy() {
		this.clearTimer();
	  },
	computed: {
	  ...mapState([
	      'userToken',
		   'userInfos',
	  ]),
	  ...mapGetters(["getUserToken"])
	},
    methods: {
		selectvlue(vlue){
			// this.fxtime4=vlue.dictLabel;
			// this.dictValue=vlue.dictValue;
			for(var i=0;i<this.options4.length;i++)
			{
				if(this.options4[i].dictLabel==this.fxtime4)
				{
					this.dictValue=this.options4[i].dictValue;
				}
			}
		},
		closeclassrequst2(){
			this.$router.back();
		},
		tokcTest(){
			// if(this.courseType==2)
			// {
			// 		this.$message({
			// 		  type: "warning",
			// 		  message: "请选择自然拼读入口，进行学习。"
			// 		});
			// 	return;	
			// }
			this.$router.push({
			    path: "/vocabulary_testlist",
				query:{
					courseId:"",
					studentId:this.studentId,
					opentype:"0",
				}
			})
		},
		timeFn() {
			var timestamp = new Date().getTime();
			if(this.attendClassEndTime-timestamp<0)
			{
				this.djtimer="00:00";
				this.countdown=0;
				return;
			}
			this.countdown=Math.floor((this.attendClassEndTime-timestamp)/1000);
		     this.timer = setInterval(() => {
		                if (this.countdown > 0) {
		                    this.countdown--;
						this.djtimer=this.formatSecound( this.countdown);
						console.log(this.djtimer);
		                } else {
		                    clearInterval(this.timer);
							this.djtimer="00:00";
		                    // 倒计时结束后需要执行的操作
		                    this.is_pause = false;
		                }
		     }, 1000);
		   },
		   clearTimer () {
		       this.timer && clearInterval(this.timer)
		    },
		 formatSecound(seconds){
			 var m=seconds ;
			var hour=Math.floor(m/60) ;
			var minutest=m%60;
			if(minutest<10)
			{
				return hour+":0"+minutest;
			}
			return hour+":"+minutest;
		},
		closeclass(){
			//結束課程
			console.log("~~~~~~~未到课程时间");
			if(this.countdown>0)
			{
				this.$message({
				  type: "warning",
				  message: "课程进行中，暂不支持提前结束"
				});
				return;
			}
				this.getliyList();
			this.dialogStartClass2=true;
		},
		closeclass2(){
			//結束課程
			if(this.countdown>0)
			{
				this.$message({
				  type: "warning",
				  message: "课程进行中，暂不支持提前结束"
				});
				return;
			}
				//結束課程
				this.teacherClassList();
				this.activityList();
				this.getliyList();
				this.dialogStartClass=true;
		},
		
        startHandle() {
            // this.$router.push({
            //     path: "/vocabulary_testlist"
            // })
            // this.dialogStartClass = true;
            this.dialogConfrimStartClass = true;
        },
		async  toWordRecognise() {
			// if(this.courseType==2)
			// {
			// 		this.$message({
			// 		  type: "warning",
			// 		  message: "请选择自然拼读入口，进行学习。"
			// 		});
			// 	return;	
			// }
			// 检验接口
			// /web/teacher/attendClass/checkCourse
			// 入参：planId 预约ID
			// type 类型  0 单词识记，2 自然拼读
			var url="/web/teacher/attendClass/checkCourse";
		    let res = await this.$api.get(url, {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				 params:{
					planId:this.planId,
					type:0,
				}
		    });
			if(res.code==200)
			{
				this.$router.push({
					path: "/word_recognise",
					query:{
						planId:this.planId,
						courseId:this.courseId,
						studentId:this.studentId,
						courseName:this.courseName,
						attendClassEndTime:this.attendClassEndTime,
					}
				})
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
        },
		toWordread() {
			if(this.courseType==2)
			{
					this.$message({
					  type: "warning",
					  message: "请选择简拼读入口，进行学习。"
					});
				return;	
			}
		    this.$router.push({
		        path: "/class_read",
				query:{
					courseId:this.courseId,
					courseName:this.courseName,
					studentId:this.studentId,
				}
		    })
		},
		async topdTest(){
			// if(this.courseType!=2)
			// {
			// 		this.$message({
			// 		  type: "warning",
			// 		  message: "请根据预约课程类型，选择学习入口。"
			// 		});
			// 	return;	
			// }
			// 检验接口
			// /web/teacher/attendClass/checkCourse
			// 入参：planId 预约ID
			// type 类型  0 单词识记，2 自然拼读
			var url="/web/teacher/attendClass/checkCourse";
			let res = await this.$api.get(url, {
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    },
				 params:{
					planId:this.planId,
					type:2,
				}
			});
			if(res.code==200)
			{
				this.$router.push({
					path: "/phonetic_alphabet_recognition",
					query:{
						planId:this.planId,
						courseId:this.courseId,
						studentId:this.studentId,
					}
				})
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
        toWordTest() {
			if(this.courseType==2)
			{
					this.$message({
					  type: "warning",
					  message: "请选择自然拼读入口，进行学习。"
					});
				return;	
			}
            this.$router.push({
                path: "/vocabulary_testlist",
				query:{
					courseId:this.courseId,
					studentId:this.studentId,
					opentype:"1",
				}
            })
        },
        startSubmit(){
            this.$router.push({
                path: "/vocabulary_testlist"
            })
        },
		async teacherClassList(){
			let res = await this.$api.get("/web/teacher/attendClass/teacherClassList",{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.options2=res.rows;
			}
		},
		async activityList(){
			let res = await this.$api.get("/web/teacher/attendClass/activityList",{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.options3=res.data;
			}
		},
		async getliyList(){
			let res = await this.$api.get("/web/teacher/attendClass/type/attend_class_end_remark",{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.options4=res.data;
				this.options4.push({"dictLabel":"无"})
			}
		},
		async closeclassrequst(index){
			console.log("~~~~~~~dictValue:"+this.dictValue);
			console.log("~~~~~~~fxtime4:"+this.fxtime4);
			// recordId 记录id 提交的时候传过来，/learnWordData 这个接口已经把这个记录id返回出去了
			// courseStartHour 复习时间 要增加21天抗遗忘才要
			var courseStartHour ="";
				var courseStartHour2 ="";
					var courseStartHour3 ="";
					
			var description="";
			if(index==1)
			{
				courseStartHour=this.fxtime;
				if(courseStartHour=="")
				{
					this.$message({
					  type: "warning",
					  message: "请选择时间"
					});
					return;
				}
				
				courseStartHour2=this.fxtime2;
				courseStartHour3=this.fxtime3;
		
				
				// if(courseStartHour2=="")
				// {
				// 	this.$message({
				// 	  type: "warning",
				// 	  message: "请选择班主任"
				// 	});
				// 	return;
				// }
			}
			
			if(this.fxtime4==""){
				this.$message({
				  type: "warning",
				  message: "请选择备注"
				});
				return;
			}
			
			if(this.dictValue==9)
			{
				if(this.appraiseText==""){
					this.$message({
					  type: "warning",
					  message: "请输入原因"
					});
					return;
				}
				description=this.fxtime4+"-"+this.appraiseText;
			}else if(this.fxtime4=="无")
			{
				description="";
			}else{
				description=this.fxtime4;
			}
			
			
			let res = await this.$api.post("/web/teacher/attendClass/learnWordConcludeSubmit",{
				planId:this.planId,
				courseStartHour:courseStartHour,
				teacherClassId:courseStartHour2,
				activityId:courseStartHour3,
				description:description,
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.$message({
				  type: "success",
				  message: "结束课程成功!"
				});
				this.dialogStartClass3=true;
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    background: #E5F3F1;

    position: relative;

    .head-box {
        width: 100%;
        height: 220px;
        position: relative;

        .head-box-bg {
            position: absolute;
            width: 100%;
            height: 470px;
            top: -80px;
        }

        .head-box-text1 {
            margin-top: 39px;
            margin-left: 212px;
            font-family: HelloFont WenYiHei;
            font-size: 50px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            color: #FFFFFF;
            position: relative;
            z-index: 30;
        }

        .head-box-text2 {
            margin-top: 3px;
            margin-left: 212px;
            font-family: 思源黑体;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            color: #FFFFFF;
            position: relative;
            z-index: 30;

        }

    }

    .content-box-col {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .content-box {
        width: 91.4777%;
        height: 466px;

        border-radius: 20px;
        opacity: 1;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        transform: translateY(-15px);


        .content-box-title {
            display: inline-block;
            margin-top: 28px;
            margin-left: 55px;
            font-family: Source Han Sans CN;
            font-size: 35px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
            position: relative;
            z-index: 30;
        }

        .content-box-bottom {
            margin-top: 21px;
            margin-left: 40px;
            width: 95.093%;
            height: 330px;
            position: relative;
            border-top: 1px solid transparent;
            box-sizing: border-box;

            .content-box-bottom-bg {
                width: 100%;
                height: 330px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-box-bottom-badge {
                width: 470px;
                height: 423px;
                position: absolute;
                top: -82px;
                right: 87px;
            }


            .content-box-main {
				cursor: pointer;
                margin-top: 72px;
                margin-left: 65px;
                width: 470px;
                height: 150px;
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                position: relative;
                z-index: 30;

                img {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                    margin-right: 14px;
                }

                .content-box-main-info {
                    div {
                        &:first-child {
                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        &:last-child {
                            margin-top: 12px;

                            font-family: Oswald;
                            font-size: 24px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 灰 */
                            color: #ACBEB0;
                        }

                    }
                }

                .content-box-main-btn {
                    margin-right: 30px;
                    text-align: center;
                    width: 134px;
                    height: 46px;
                    border-radius: 100px;
                    opacity: 1;

                    /* 绿 */
                    background: #0AA26B;
                    font-family: Source Han Sans CN;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 46px;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

            }

        }

    }

    .content-box2 {
        width: 91.4777%;
        height: 650px;

        border-radius: 20px;
        opacity: 1;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        transform: translateY(-15px);

        .content-box2-tips {
            margin-top: 21px;
            margin-left: 23px;

            img {
                margin-right: 8px;
                width: 24px;
                height: 24px;
            }

            span {
                font-family: Source Han Sans CN;
                font-size: 18px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

        }

        .content-box-titlebox {
            margin-top: 38px;
            margin-left: 55px;
            align-items: flex-end;
        }

        .content-box-title {
            display: inline-block;
            font-family: Source Han Sans CN;
            font-size: 40px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
            position: relative;
            z-index: 30;
        }

        .content-box-title2 {
            margin-left: 29px;
            font-family: Source Han Sans CN;
            font-size: 30px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
			position: relative;
			z-index: 30;
        }

        .content-box-bottom {
            margin-left: 40px;
            width: 95.093%;
            height: 490px;
            position: relative;
            border-top: 1px solid transparent;
            box-sizing: border-box;

            .content-box-bottom-bg {
                width: 100%;
                height: 490px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-box-bottom-badge {
                width: 470px;
                height: 423px;
                position: absolute;
                top: -60px;
                right: 97px;
            }

            .content-box-mainbox {
                margin-top: 60px;
                margin-left: 49px;
            }

            .content-box-main {
                margin-right: 20px;
                width: 274px;
                height: 150px;
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                position: relative;
                z-index: 30;

                img {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                    margin-right: 14px;
                }

                .content-box-main-info {
                    div {
                        &:first-child {

                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        &:last-child {
                            margin-top: 12px;

                            font-family: Oswald;
                            font-size: 24px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 灰 */
                            color: #ACBEB0;
                        }

                    }
                }



            }

            .content-box-btnsbox {
                margin-top: 30px;
                margin-left: 49px;
                position: relative;
                z-index: 20;

                div {
                    &:first-child {
                        text-align: center;
                        margin-right: 22px;
                        width: 134px;
                        height: 46px;
                        border-radius: 100px;

                        /* 绿 */
                        background: #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 纯白 */
                        color: #FFFFFF;
                    }

                    &:last-child {
                        text-align: center;
                        width: 261px;
                        height: 46px;
                        border-radius: 100px;

                        box-sizing: border-box;
                        /* 绿 */
                        border: 2px solid #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }

                }
            }

        }

    }

    .appraise-popup-title {
        width: 100%;
        height: 86px;
        border-radius: 20px 20px 0 0;
        background: #0AA26B;
        box-sizing: border-box;
        padding: 0 35px;

        .appraise-popup-title-name {
            font-family: 思源黑体;
            font-size: 26px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        img {
            width: 56px;
            height: 56px;
        }
    }

    .start-popup-content {
        background: #fff;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;
        padding: 0 52px;

        .start-popup-content-text1 {
            margin-left: 173.5px;
            margin-top: 89px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }
		
		.start-popup-content-text2 {
		    font-family: 思源黑体;
			text-align: center;
		    font-size: 22px;
		    font-weight: normal;
		    font-feature-settings: "kern" on;
		    /* 333333 */
		    color: #333333;
		}

        .start-popup-content-timebox {
            margin-top: 30px;
            margin-left: 173.5px;

            span {
                margin-right: 30px;
                font-family: 思源黑体;
                font-size: 22px;
                font-weight: normal;
                line-height: 30px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

            .content-box2-select {
                width: 195px;
                height: 64px;
                border-radius: 100px;
                opacity: 1;

                // background: #E5F7F1;

                box-sizing: border-box;
                // border: 1px solid rgba(10, 162, 107, 0.2);
            }

        }
		
		
		.start-popup-content-timebox2 {
		    margin-top: 30px;
			text-align: center;
			
		    span {
		        font-family: 思源黑体;
		        font-size: 22px;
		        font-weight: normal;
		        line-height: 30px;
		        letter-spacing: 0em;
		
		        font-feature-settings: "kern" on;
		        /* 333333 */
		        color: #333333;
		    }
		
		    .content-box2-select {
		        width: 195px;
		        border-radius: 100px;
		        opacity: 1;
		
		        // background: #E5F7F1;
		
		        box-sizing: border-box;
		        // border: 1px solid rgba(10, 162, 107, 0.2);
		    }
		
		}

        .start-popup-content-tipsbox {
            margin-top: 89px;
            margin-bottom: 75px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 确认开始学员 */
            color: #333333
        }

        .start-popup-content-line {
            margin-top: 30px;
            width: 100%;
            height: 0px;
            opacity: 1;

            border: 1px solid rgba(10, 162, 107, 0.2);
        }

        .start-popup-content-btnsbox {
            margin-top: 31px;
            margin-bottom: 30px;

            div {
                &:first-child {
                    margin-right: 20px;
                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 灰 */
                    background: #ACBEB0;
                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

                &:last-child {

                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 绿 */
                    background: #0AA26B;

                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }
            }
        }

    }


}
 .appraise-popup-content-textbox-input {
            width: 350px;
            border-radius: 20px;
			margin-top: 10px;
			margin-left: auto;
			margin-right: auto;

            /deep/ .el-textarea__inner {
                background: #E5F7F1;
                font-family: 思源黑体;
                font-size: 18px;
                font-weight: normal;
                line-height: normal;
                display: flex;
                align-items: center;
                letter-spacing: 0em;

                /* 灰 */
                color: #ACBEB0;
                box-sizing: border-box;
                border: 1px solid rgba(10, 162, 107, 0.2);

            }
        }


/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>